import { Service } from '@wix/ambassador-bookings-services-v2-service/types';
import { BookingsSettings } from '@wix/ambassador-bookings-v2-bookings-settings/types';
import {
  isAppointmentService,
  isServiceWithDynamicDuration,
  isServiceWithAddOns,
  isBookFlowSettingsEnabled,
} from '@wix/bookings-calendar-catalog-viewer-mapper';
import { shouldOpenPreferencesModal as shouldOpenPreferencesModalUtil } from '@wix/bookings-services-preferences-modal/utils';
import Experiments from '@wix/wix-experiments';

export interface BookButtonViewModel {
  isPendingApprovalFlow?: boolean;
  navigationInitiatedBy?: string;
  shouldOpenServicesPreferencesModal?: boolean;
}

export const bookButtonViewModelFactory = (
  service: Service,
  isMultiServiceAppointmentEnabled: boolean,
  experiments: Experiments,
  bookingsSettings?: BookingsSettings,
): BookButtonViewModel => {
  if (
    !isBookFlowSettingsEnabled({
      experiments,
      bookingsSettings,
    })
  ) {
    return bookButtonViewModelFactoryDeprecated(
      service,
      isMultiServiceAppointmentEnabled,
    );
  }

  let shouldOpenServicesPreferencesModal = false;

  if (bookingsSettings) {
    shouldOpenServicesPreferencesModal = shouldOpenPreferencesModalUtil({
      service,
      bookingsSettings,
      experiments,
    });
  }

  return {
    isPendingApprovalFlow: service?.onlineBooking?.requireManualApproval!,
    shouldOpenServicesPreferencesModal,
  };
};

const bookButtonViewModelFactoryDeprecated = (
  service: Service,
  isMultiServiceAppointmentEnabled: boolean,
): BookButtonViewModel => {
  const isMultiServiceAppointmentFlow =
    isMultiServiceAppointmentEnabled && isAppointmentService(service);

  const shouldOpenForDynamicDurationOrMSA =
    isMultiServiceAppointmentFlow || isServiceWithDynamicDuration(service);

  const shouldOpenForAddOns =
    isServiceWithAddOns(service) && isAppointmentService(service);

  return {
    isPendingApprovalFlow: service?.onlineBooking?.requireManualApproval!,
    shouldOpenServicesPreferencesModal:
      shouldOpenForDynamicDurationOrMSA || shouldOpenForAddOns,
  };
};
